<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}

.required_err {
  color: rgba(255, 0, 0);
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
<div>
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        sort-by="id"
        class="elevation-1"
        @dblclick:row="on_dbl_click">

    <template v-slot:top>
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">PPPoE IPv6 subscribers</h2></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">

            <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card>
                <v-card-title>
                    <span class="headline">{{ edit_caption }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container style="height: 520px; overflow-y: scroll;">
                        <v-row>

                    <v-col cols="12">
                        <v-btn v-if="edited_index !== -1" color="blue darken-2"
                            text @click="disconnect">Disconnect
                        </v-btn>

                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.id"
                            label="ID"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.username"
                            label="Username"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.mac"
                            label="MAC"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.port_id"
                            label="Port"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.svid"
                            label="SVID"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.cvid"
                            label="CVID"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.ia_na"
                            label="IA NA"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.ia_pd"
                            label="Delegated prefix"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.slaac"
                            label="SLAAC"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.mtu"
                            label="MTU"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.ingress_shaper"
                            label="Ingress Qdisc"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.egress_shaper"
                            label="Egress Qdisc"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.rxp"
                            label="RX pkts"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.txp"
                            label="TX pkts"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.rxb"
                            label="RX bytes"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.txb"
                            label="TX bytes"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.connected_at"
                            label="Connected at"
                        ></v-text-field>
                        <v-text-field
                            v-bind:readonly="true"
                            v-model="edited_item.uptime"
                            label="Uptime"
                        ></v-text-field>
                    </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="edited_index !== -1" color="blue darken-1"
                        text @click="close">Close</v-btn>
                </v-card-actions>
            </v-card></ValidationObserver>

            </v-dialog>
        </v-toolbar>
    
        <v-toolbar flat>
            <v-text-field v-model="search"
                append-icon="mdi-magnify" label="Search" single-line hide-details
            ></v-text-field>
        </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
        <v-icon small class="me-2" @click="edit_item(item)">
            mdi-pencil
        </v-icon>
    </template>

    <template v-slot:no-data>
    </template>

    </v-data-table>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import "../validation_rules.js";

export default {
name: "pppoe_ipv6_subsc",
components: { 
    Treeselect, ValidationProvider, ValidationObserver,
},
data: () => ({
    edit_caption: '',
    search: '',
    dialog: false,

    // { text: 'Connected at', value: 'connected_at' },

    headers: [
        { text: 'Id', value: 'id', align: 'start' },
        { text: 'Username', value: 'username' },
        { text: 'MAC', value: 'mac' },
        { text: 'Port', value: 'port_id' },
        { text: 'SVID', value: 'svid' },
        { text: 'CVID', value: 'cvid' },
        { text: 'IA NA', value: 'ia_na' },
        { text: 'Delegated Prefix', value: 'ia_pd' },
        { text: 'SLAAC', value: 'slaac' },
        { text: 'Ingress Qdisc', value: 'ingress_shaper' },
        { text: 'Egress Qdisc', value: 'egress_shaper' },
        { text: 'RX pkts', value: 'rxp' },
        { text: 'TX pkts', value: 'txp' },
        { text: 'RX bytes', value: 'rxb' },
        { text: 'TX bytes', value: 'txb' },
        { text: 'Uptime', value: 'uptime', width: '300px' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],

    items: [],
    edited_index: -1,
    edited_item: {
    },
}),

watch: {
},

created() {
    this.initialize()
},

methods: {
    initialize() {
        return new Promise((resolve, reject) => {
            api_client.run_get_query('/pppoe/ipv6_subsc')
            .then(response => {
                this.items = response.data;
                resolve(response);
            })
            .catch(error => {
                console.log(error);
            });
        });
    },

    edit_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.edit_caption = 'PPPoE IPv6 subscriber';
        this.dialog = true;
    },

    on_dbl_click(event, data) {
        this.edit_item(data.item);
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.edited_index = -1;
        });
    },

    disconnect() {
        this.$confirm("Are you sure you want to disconnect PPPoE subscriber with username '" + 
            this.edited_item.username + "', id " + this.edited_item.id + " ?")
        .then(() => {
            this.disconnect_act()
        });
    },

    disconnect_act() {
        api_client.run_post_query("/pppoe/disconnect", {
            id: this.edited_item.id
        })
        .then(response => {
            this.items.splice(this.edited_index, 1);
            this.close();
        })
        .catch(error => {
            console.log(error);
        });
    },    
}

};
</script>
